import React from 'react';
import { ValidateResponse_Term } from '@qover-private/protos-web/qover/dojo/terms/v1/terms';
import { SummaryTermsCardContainer } from './summaryTerms.styles';
import messages from './summaryTerms.messages';

type SummaryTermsProps = {
  terms: ValidateResponse_Term;
  summaryCardStyle?: React.CSSProperties;
};

export const SummaryTerms: React.FC<SummaryTermsProps> = props => (
  <SummaryTermsCardContainer style={props.summaryCardStyle}>
    <h4 className="color-primary">{messages.title}</h4>
    {props.terms && Array.isArray(props.terms.texts) && (
      <ul>
        {props.terms.texts
          .filter(text => text.type !== 'dataShareConsent')
          .map(text =>
            text.value?.split('\n').map(line => <li key={line}>{line}</li>),
          )}
      </ul>
    )}
  </SummaryTermsCardContainer>
);
